import { render, staticRenderFns } from "./ImgSlide.vue?vue&type=template&id=21ccbd92&scoped=true&"
import script from "./ImgSlide.vue?vue&type=script&lang=js&"
export * from "./ImgSlide.vue?vue&type=script&lang=js&"
import style0 from "./ImgSlide.vue?vue&type=style&index=0&id=21ccbd92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ccbd92",
  null
  
)

export default component.exports